
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.7 17.64l-6.5-2.58a.5.5 0 00-.36 0l-6.5 2.58a.5.5 0 000 .93l.32.13v2.73a.5.5 0 001 0V19.1l1.42.56v2.75c0 .1.03.17.08.25.35.99 2.6 1.37 4.06 1.37 1.57 0 3.24-.42 3.58-1.31a.48.48 0 00.07-.24V19.7l2.84-1.13a.5.5 0 000-.93zm-3.83 4.73c-.1.2-.99.66-2.65.66-1.67 0-2.98-.47-3.12-.65l-.02-.1v-2.22l2.76 1.1a.51.51 0 00.37 0l2.66-1.06v2.27zm-2.85-2.22l-5.14-2.04 5.14-2.05 5.15 2.05-5.15 2.04zM4.16 21.43h4.56a.5.5 0 000-1H4.15a.5.5 0 000 1zM9.47 23H4.16a.5.5 0 000 1h5.31a.5.5 0 000-1zm4.36-15.35a7.81 7.81 0 01-.83 2.93 43.84 43.84 0 00-1.74 4.3.5.5 0 10.94.34c.5-1.4 1.16-3.15 1.69-4.18.53-1.04.86-2.22.94-3.32A7.26 7.26 0 0010.37.6a7.4 7.4 0 00-8.3 1.67 7.26 7.26 0 00-1.35 8.27c1.07 2.16 2.19 4.4 2.67 6.84.12.65.68 1.11 1.32 1.11h3.26a.5.5 0 000-1H4.71a.35.35 0 01-.34-.3c-.5-2.57-1.65-4.87-2.76-7.1A6.26 6.26 0 012.8 2.97a6.4 6.4 0 017.18-1.44 6.26 6.26 0 013.85 6.12z"}})])
          )
        }
      }
    